// @flow

import {
  MAX_EARNINGS_FOR_SLIDER,
  MAX_STUDENT_POPULATION_FOR_SLIDER,
  MAX_NET_PRICE_FOR_SLIDER,
} from './Constants';

import { measures } from './Measures';

const initialState = {
  loading: true,
  countiesGeoJSON: {},
  selectedCollege: null,
  measures,
  selectedMeasure: measures[2],
  selectedDependentMeasure: measures[3],
  selectedIndependentMeasure: measures[8],
  highDegreeFilter: {
    enabled: true,
    value: '3',
    filterName: 'highDegreeFilter',
  },
  lastUpdate: 0,
  colleges: [],
  programFilter: {
    enabled: false,
    filterName: 'programFilter',
    options: [],
    value: -1,
  },
  populationFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: true,
    filterName: 'populationFilter',
    limits: { min: 0, max: MAX_STUDENT_POPULATION_FOR_SLIDER },
    step: 1000,
    value: { min: 5000, max: 20000 },
  },
  nameFilter: {
    enabled: false,
    value: '',
    filterName: 'nameFilter',
  },
  admissionRateFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'admissionRateFilter',
    limits: { min: 0.0, max: 1.0 },
    step: 0.01,
    value: { min: 0.25, max: 0.5 },
  },
  ontimeCompletionFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'ontimeCompletionFilter',
    limits: { min: 0.0, max: 1.0 },
    step: 0.01,
    value: { min: 0.25, max: 0.5 },
  },
  extraTimeCompletionFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'extraTimeCompletionFilter',
    limits: { min: 0.0, max: 1.0 },
    step: 0.01,
    value: { min: 0.25, max: 0.5 },
  },
  repaymentAtSevenFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'repaymentAtSevenFilter',
    limits: { min: 0.0, max: 1.0 },
    step: 0.01,
    value: { min: 0.25, max: 0.5 },
  },
  earningsAtTenFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'earningsAtTenFilter',
    limits: { min: 0, max: MAX_EARNINGS_FOR_SLIDER },
    step: 5000,
    value: { min: 25000, max: 50000 },
  },
  satFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'satFilter',
    limits: { min: 600, max: 1600 },
    step: 50,
    value: { min: 900, max: 1300 },
  },
  actFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'actFilter',
    limits: { min: 8, max: 36 },
    step: 1,
    value: { min: 18, max: 29 },
  },
  netPriceFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'netPriceFilter',
    limits: { min: 0, max: MAX_NET_PRICE_FOR_SLIDER },
    step: 1000,
    value: { min: 8000, max: 16000 },
  },
  inStateTuitionFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'inStateTuitionFilter',
    limits: { min: 0, max: MAX_NET_PRICE_FOR_SLIDER },
    step: 1000,
    value: { min: 8000, max: 16000 },
  },
  outOfStateTuitionFilter: {
    animationDirection: 1,
    animationEnabled: false,
    enabled: false,
    filterName: 'outOfStateTuitionFilter',
    limits: { min: 0, max: MAX_NET_PRICE_FOR_SLIDER },
    step: 1000,
    value: { min: 8000, max: 16000 },
  },
  statesGeoJSON: {},
};

export { initialState };



// WEBPACK FOOTER //
// ./src/App/State.js